
import { Avatar, AvatarFallback } from "@/components/ui/avatar";
import { getInitials } from "../ClientUtils";

interface ClientAvatarProps {
  firstName: string;
  lastName: string;
}

export function ClientAvatar({ firstName, lastName }: ClientAvatarProps) {
  return (
    <Avatar className="h-16 w-16 mb-2">
      <AvatarFallback className="bg-primary/10 text-primary text-xl">
        {getInitials(firstName, lastName)}
      </AvatarFallback>
    </Avatar>
  );
}
